const PAID_PLANS = new Set([
  "Starter", "Creator", "Business", "Agency", "Enterprise Basic",
  "Enterprise Plus", "Enterprise Advanced", "Enterprise Elite", "Enterprise Unlimited",
]);

export function isEnterpriseTestAccount(user) {
  const own = !user?.active_workspace || user.active_workspace === user?.id;
  return own && String(user?.email || "").toLowerCase() === "info+taaft1@casahaya.com"
    && PAID_PLANS.has(user?.subscription_plan)
    && user.subscription_plan.startsWith("Enterprise ");
}

// UI parity only: the server independently checks its stored account and owner.
export function hasCollaborationAccess(user) {
  return PAID_PLANS.has(user?.subscription_plan) && (
    isEnterpriseTestAccount(user) || (!user?.is_trial && (
      user?.subscription_status === "active" || (user?.is_founder && user?.billing_exempt)
    ))
  );
}
